<!-- Coming Soon Gate (controlled by admin system features, bypassed for share links) -->
<app-coming-soon *ngIf="showComingSoon$ | async"></app-coming-soon>

<!-- App (rendered when coming soon is disabled OR on a bypass route like /share/file/) -->
<ng-container *ngIf="!(showComingSoon$ | async)">
  <router-outlet></router-outlet>

  <app-loading-overlay *ngIf="loading$ | async" message="Preparing your session..."></app-loading-overlay>

  <app-pwa-install-banner></app-pwa-install-banner>

  <app-confirm-dialog></app-confirm-dialog>

  <app-reauth-dialog></app-reauth-dialog>

  <app-external-viewer-dialog></app-external-viewer-dialog>
</ng-container>
